import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';

const HeroSection = () => {
  return (
    <section className="relative bg-[#002554] overflow-hidden">
      {/* Blueprint grid pattern with gradient lighting effect */}
      <div 
        className="absolute inset-0"
        style={{
          background: `
            linear-gradient(135deg, 
              rgba(0, 53, 148, 0.4) 0%, 
              rgba(0, 37, 84, 0.1) 30%,
              rgba(0, 37, 84, 0.1) 70%,
              rgba(0, 53, 148, 0.3) 100%
            )
          `
        }}
      />
      
      {/* Tight blueprint grid - smaller squares */}
      <div 
        className="absolute inset-0"
        style={{
          backgroundImage: `
            linear-gradient(rgba(0, 53, 148, 0.5) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0, 53, 148, 0.5) 1px, transparent 1px)
          `,
          backgroundSize: '24px 24px'
        }}
      />
      
      {/* Secondary finer grid overlay */}
      <div 
        className="absolute inset-0"
        style={{
          backgroundImage: `
            linear-gradient(rgba(0, 53, 148, 0.2) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0, 53, 148, 0.2) 1px, transparent 1px)
          `,
          backgroundSize: '6px 6px'
        }}
      />

      {/* Gradient light sweep from top-left */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: `
            radial-gradient(ellipse 80% 50% at 20% 30%, 
              rgba(0, 53, 148, 0.6) 0%, 
              transparent 60%
            )
          `
        }}
      />
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-16 md:pt-12 md:pb-20">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          {/* Left side - Text content */}
          <div className="max-w-2xl">
            {/* Status badge - keeping green as requested */}
            <div className="inline-flex items-center bg-[#002554]/80 backdrop-blur-sm rounded-full px-4 py-2 mb-8 border border-[#003594]/30">
              <span className="w-2 h-2 bg-green-400 rounded-full mr-2 animate-pulse"></span>
              <span className="text-white text-sm font-medium">Open for submissions</span>
            </div>

            {/* Main heading */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
              COLLECTORS FIRST.<br />
              <span className="text-white">ALWAYS NICE.</span>
            </h1>

            {/* Subtitle - IMPROVED: Changed from #B2B4B2 to white/90 for better contrast on dark blue */}
            <p className="text-lg md:text-xl text-white/90 font-medium mb-10 max-w-2xl leading-relaxed">
              Powering the revolution one slab at a time with rapid turnaround times and zero upcharges.
            </p>

            {/* CTA Button */}
            <Link to="/new-submission">
              <Button 
                className="bg-white text-[#003594] hover:bg-gray-100 px-8 py-6 text-base font-semibold rounded-md inline-flex items-center gap-2 transition-all duration-200 hover:translate-x-1"
              >
                START SUBMISSION
                <ChevronRight className="w-5 h-5" />
              </Button>
            </Link>
          </div>

          {/* Right side - Graded card image */}
          <div className="hidden lg:block flex-shrink-0">
            <div className="relative">
              {/* Subtle glow effect behind card */}
              <div className="absolute inset-0 bg-white/10 blur-2xl rounded-full scale-75"></div>
              <img 
                src="https://customer-assets.emergentagent.com/job_845bc91a-08d6-4fd2-80e4-d5fe5bbe0d3c/artifacts/9jw9uksp_DSC_2882-Edit-2-1000x1500.png"
                alt="NICE Graded Card"
                className="relative w-[500px] h-auto rounded-lg transform rotate-6 hover:rotate-0 hover:scale-105 transition-all duration-500 ease-out"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
